import React, { useEffect } from "react";
import { Layout, notification, ConfigProvider, theme as antdTheme } from "antd";
import { HeaderContent, MenuTop } from "../components/AdminLayout";
import "./LayoutAdmin.css";
import { useTheme } from "../context/ThemeContext";
import {
  KEY_NOTIFICATION_FIREBASE,
  TOKEN_NOTIFICATION,
  USERID,
} from "../config/constants";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../Services/firebase";
import { BACKEND_URL } from "../config/config";

import axios from "axios";
import { useNotification } from "../context";

export function LayoutAdmin({ children }) {
  const [api, contextHolder] = notification.useNotification();
  const { updateNotification } = useNotification();
  const userID = localStorage.getItem(USERID);

  useEffect(() => {
    // Verificar si las notificaciones son compatibles y si ya se ha otorgado permiso.
    if ("Notification" in window && "PushManager" in window) {
      if (Notification.permission === "granted") {
        activarMensajes();
        console.log("usuario con notificacion activada");
        // El usuario ya ha otorgado permiso para notificaciones.
      } else if (Notification.permission !== "denied") {
        // El usuario aún no ha otorgado ni denegado permiso para notificaciones.
        // Debes solicitar permiso al usuario.
        console.log(
          "El usuario aún no ha otorgado ni denegado permiso para notificaciones.",
        );

        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            // El usuario ha otorgado permiso para notificaciones.
            // Puedes mostrar notificaciones aquí si es necesario.
            activarMensajes();

            console.log(
              "/ El usuario ha otorgado permiso para notificaciones.",
            );
            activarMensajes();
          } else {
            // El usuario ha denegado el permiso para notificaciones.
            // Puedes mostrar un mensaje al usuario explicando cómo habilitar notificaciones en la configuración de su dispositivo.
            console.log(
              "El usuario ha denegado el permiso para notificaciones.",
            );
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userID]);

  const activarMensajes = async () => {
    console.log("Activar Mensajes desde: ", BACKEND_URL);
    const token = await getToken(messaging, {
      vapidKey: KEY_NOTIFICATION_FIREBASE,
    }).catch((error) =>
      console.log("Tuviste un error al generar el token", error),
    );

    if (token && userID) {
      console.log("token", token);
      try {
        const url = `${BACKEND_URL}/customers/addDeviceID`;

        const data = {
          contact: userID,
          deviceID: token,
        };

        const response = await axios.post(url, data);

        if (response.status === 200) {
          console.log("token registrado correctamente notification");
          console.log("tu token:", token);
          localStorage.setItem(TOKEN_NOTIFICATION, token);
        }
      } catch (error) {
        console.log("error al guardar token");
      }
    }
    if (!token) console.log("no tienes token");
  };

  const openNotification = (message) => {
    api.info({
      message: message.notification.title,
      description: message.notification.body,
      duration: 4,
    });
    updateNotification(message.notification.body + new Date());
    // const senderUserIDs = JSON.parse(message.data.senderUserIDs);
    // if (senderUserIDs.includes(userID)) {
    //   console.log("si recibo el mensajes", message);
    //   try {
    //     console.log("abriendo notificacion");
    //     api.info({
    //       message: message.notification.title,
    //       description: message.notification.body,
    //       duration: 4,
    //     });
    //     updateNotification(message.notification.body + new Date());
    //   } catch (err) {
    //     console.log("error al generar notificacion push", err);
    //   }
    // } else {
    //   console.log("NO recibo el mensajes");

    //   return;
    // }
  };

  React.useEffect(() => {
    onMessage(messaging, (message) => {
      openNotification(message);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { Content, Header } = Layout;

  const { themeMode } = useTheme();

  return (
    <ConfigProvider
      theme={{
        algorithm: themeMode === "dark" ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: "#2563eb",
          colorInfo: "#0ea5a3",
          colorSuccess: "#16a34a",
          colorWarning: "#f59e0b",
          colorError: "#dc2626",
          borderRadius: 8,
          colorBgContainer: themeMode === "dark" ? "#111827" : "#ffffff",
          colorBgElevated: themeMode === "dark" ? "#182032" : "#ffffff",
        },
      }}
    >
      <Layout className="layoutContainer">
        <Layout className="layout-admin">
          <Header className="layout-admin__header">
            <MenuTop />
          </Header>
          <Content className="layout-admin__content">
            <div className="layout-admin__subheader">
              <HeaderContent />
            </div>
            <div className="admin-children-container">{children}</div>
          </Content>
        </Layout>
      </Layout>
      {contextHolder}
    </ConfigProvider>
  );
}
